// extracted by mini-css-extract-plugin
export default {"placeholder":"BookingSearchBox_placeholder__5LXS9"};